
<template>
  <div>
    <div class="group-member-wrapper">
      <div class="group-member-list" v-for="(item, index) in groupList" :key="index" @click="jump(item)">
        <img class="group-member-list-img" :src="item.half_length_portrait || defaultHalfPortrait"  alt="半身像">
        <div v-if="item.leader === 1" class="group-member-list-leader">组长</div>
        <div :class="item.leader === 1 ? 'group-member-list-name' : 'group-member-list-name-leader'">{{item.name}}</div>
        <div class="group-member-list-company">{{item.company}}</div>
      </div>
    </div>
    <div class="see-more" v-if="groupList.length < memberList.length">
      <span class="see-more-text" @click="addMore">查看更多</span>
    </div>
  </div>
</template>

<script>

import { defaultHalfPortrait } from '@/data/default'

export default {
  props: ['memberList', 'sliceQuantity'],
  data () {
    return {
      groupList: [],
      defaultHalfPortrait
    }
  },
  methods: {
    addMore () {
      console.log('groupList', this.groupList)
      this.groupList = this.memberList
    },
    showGroup () {
      this.groupList = this.memberList.slice(0, Number(this.sliceQuantity))
    },
    jump (item) {
      const itemUid = item.user_id
      this.$router.push({ path: '/we/members', query: { uid: itemUid } }).catch(() => {})
    }
  },
  computed: {
  },
  components: {
  },
  watch: {
    memberList: {
      handler: function () {
        this.showGroup()
      },
      deep: true,
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>

.group-member-wrapper {
  display: flex;
  flex-wrap: wrap;
}

.group-member-list {
  width: 160px;
  margin: 0 34px 40px 0;
  text-align: left;
  overflow: hidden;

  &:nth-child(4n) {
    margin-right: 0;
  }
}

.group-member-list-img {
  width: 160px; height: 205px;
  border-radius: 4px;
}

.group-member-list-leader {
  margin: 6px 0;
  line-height: 22px;
  font-size: 16px; font-weight: 400;
  color: #D7B375;
}

.group-member-list-name-leader {
  margin: 32px 0 6px;
  line-height: 28px;
  font-size: 16px; font-weight: 500;
  color: #353535;
}

.group-member-list-name {
  margin-bottom: 5px;
  line-height: 28px;
  font-size: 16px; font-weight: 500;
  color: #353535;
}

.group-member-list-company {
  line-height: 20px;
  font-size: 14px; font-weight: 500;
  color: #888888;
}

.see-more {
  display: flex;
  justify-content: center;
  margin: 8px 0 40px;
}

.see-more-text {
  width: 160px; height: 38px;
  padding: 8px 0;
  color: #D7B375;
  border-radius: 4px;
  border: 1px solid #D7B375;
  line-height: 22px;
  text-align: center;
  font-size: 16px; font-weight: 400;
  cursor: pointer;
}

</style>
